import React from "react";
import { useTranslation } from "react-i18next";

import {
  QuestionComponentProps,
  QuestionDefinition,
  QuestionOption,
} from "@/components/survey/Question";
import { MultipleChoiceQuestion } from "@/components/survey/questionTypes/core";
import { isB2CPartner } from "@/utils/partners";

const QUESTION_ID = "diabetesDiagnosis";

declare module "@/contexts" {
  interface SurveyAnswers {
    diabetesDiagnosis?: string;
  }
}

const DiabetesDiagnosisQuestion: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { t } = useTranslation();

  const options: QuestionOption[] = [
    { id: "yes", text: t("diabetesDiagnosis.options.yes") },
    { id: "no", text: t("diabetesDiagnosis.options.no") },
  ];

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={options}
      questionId={QUESTION_ID}
      questionText={t("diabetesDiagnosis.questionText")}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_DIABETES_DIAGNOSIS: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["WEIGHT", "DPP", "DIABETES_LIFESTYLE", "MED", "NMPBA"],
  shouldShowQuestion: ({ partnerInfo }) => !isB2CPartner(partnerInfo),
  component: DiabetesDiagnosisQuestion,
};
